module.exports = __webpack_public_path__ + "static/img/shuiguopaidui.045b481.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/shuiguopaidui.jpg
// module id = UHeo
// module chunks = 0